<template>
  <v-card class="mx-auto payment-block" max-width="380px">
    <v-card-title class="mx-auto payment-block-title">
      <div class="payment-title">
        <h3 class="price-title">{{ title }}</h3>
        <h3 class="text-center sub-title">{{ subTitle }}</h3>
      </div>
      <p v-if="blurb" class="price-blurb text-center">{{ blurb }}</p>
    </v-card-title>
    <v-card-text class="payment-plan-text">
      <div v-for="(value, name, i) in benefits" :key="i" class="mb-2">
        <h4>{{ name }}</h4>
        <v-list class="py-0">
          <v-list-item
            v-for="(item, key) in value"
            :key="key"
            class="benefit-list-item"
          >
            <v-list-item-action>
              <v-icon color="primary">{{ icons.mdiCheckCircle }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="benefit-list-item-title">{{
                item
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-card-text>
    <v-card-actions v-if="linkPath" class="py-6">
      <v-btn
        rounded
        depressed
        x-large
        color="primary"
        class="mx-auto"
        :to="linkPath"
        ><span>{{ linkText }}</span></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'PaymentPlanBlock',
    props: {
      title: {
        required: true,
        type: String,
      },
      benefits: {
        required: true,
        type: Object,
      },
      subTitle: {
        required: true,
        type: String,
      },
      linkPath: {
        required: false,
        type: String,
        default: null,
      },
      linkText: {
        required: false,
        type: String,
        default: 'Select',
      },
      blurb: {
        required: false,
        type: String,
        default: null,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .payment-plan-text {
    padding: 16px;

    h4 {
      color: rgba(0, 0, 0, 0.87);
      font-size: 16px;
    }
  }

  .payment-title {
    margin: auto;
    margin-top: 0;
  }

  .payment-block-title {
    min-height: 136px;
    border-radius: 0 !important;

    .price-title {
      width: 100%;
      text-align: center;
      font-size: 18px;
    }

    .sub-title {
      font-size: 20px;
      color: #fff;
      background-color: black;
      border: 1px solid black;
      border-radius: 3px;
      padding-left: 7px;
      padding-right: 7px;
      margin-top: 7px;
      margin-bottom: 7px;
    }

    .price-blurb {
      font-size: 15px;
      font-weight: 400;
      margin: 0 auto 0 auto;
    }
  }

  .benefit-list-item {
    min-height: 60px;
    padding: 0 15px;

    .benefit-list-item-title {
      white-space: normal;
      overflow: initial;
      font-size: 15px;
    }
  }

  .payment-block {
    border: 3px solid;
    border-radius: 3px;
    margin-bottom: 15px;
  }

  @media screen and (max-width: 600px) {
    .price-title {
      font-size: 16px;
    }
    .sub-title {
      font-size: 18px;
    }
    h4 {
      font-size: 14px;
    }
    .price-blurb,
    .v-list__tile__title {
      font-size: 13px;
    }
  }
</style>
